/* ==============================================================
   TTW INLINE JS - EK CACHEABLE FILE (10 Aug 2026)

   PEHLE: 10 chhote scripts har page ke HTML mein inline jate the
   (~21KB), aur har page par dobara download hote the.

   AB: ek external file, defer ke sath - HTML parse hone ke BAAD
   chalti hai. Sab blocks pehle se hi DOM-ready ka intezar karte
   the (DOMContentLoaded / readyState / delegated listeners), is
   liye defer se timing behtar hui hai, kharab nahi.

   TARTEEB wahi hai jo document mein thi. Har block apna alag
   IIFE hai, ek doosre par depend nahi karta.

   Jin scripts mein Liquid values thin (ttw-quickadd ka config,
   ttw-pdp ke <template> blocks, ttw-nudge ka config) unhe haath
   nahi lagaya - woh inline hi hain.
   ============================================================== */

/* ===== ttw-filter script #0 ===== */
(function () {
  'use strict';
  function closeAll(except) {
    var groups = document.querySelectorAll('.filter-container .filter-group');
    Array.prototype.forEach.call(groups, function (g) {
      if (g === except) return;
      if (g.classList.contains('filter-group--applied')) return;
      var items = g.querySelector('.filter-group__items');
      var head = g.querySelector('.filter-group__heading');
      if (items) items.classList.add('toggle-target--hidden');
      if (head) head.classList.add('toggle-target-toggler--is-hidden');
    });
  }
  document.addEventListener('click', function (e) {
    if (window.innerWidth < 900) return;
    if (!e.target.closest) return;
    var head = e.target.closest('.filter-container .filter-group__heading');
    if (head) { setTimeout(function () { closeAll(head.parentNode); }, 10); return; }
    if (!e.target.closest('.filter-container .filter-group')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();

/* ===== ttw-bleed script #0 ===== */
(function () {
  'use strict';
  function setVW() {
    var w = document.documentElement.clientWidth;
    if (w > 0) document.documentElement.style.setProperty('--ttw-vw', w + 'px');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setVW);
  } else {
    setVW();
  }
  window.addEventListener('load', setVW);
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(setVW, 100);
  });
})();

/* ===== ttw-final TTW_TILE (11 Aug): wapas ttw-final.liquid mein =====
   10 Aug ke move mein DONO TTW_TILE assignments bina Liquid shart ke
   yahan aa gaye the - is liye HAR collection (father-son samet) par
   "$99 both" wala tile ban raha tha. Ab ye dobara ttw-final.liquid ke
   tile_mode conditionals ke andar inline hain. ===== */

/* ===== ttw-final script #2 ===== */
(function () {
  'use strict';

  function money(t) {
    var m = String(t || '').replace(/[^0-9.]/g, '');
    var v = parseFloat(m);
    return isFinite(v) ? v : null;
  }
  function labels() {
    var cards = document.querySelectorAll('.product-block');
    Array.prototype.forEach.call(cards, function (card) {
      var lab = card.querySelector('.product-label--sale span');
      if (!lab || lab.getAttribute('data-ttw') === '1') return;
      var cmp = card.querySelector('.product-price__compare');
      var row = card.querySelector('.product-price');
      if (cmp && row) {
        var was = money(cmp.textContent);
        var now = money(row.textContent.replace(cmp.textContent, ''));
        if (was && now && was > now) {
          lab.textContent = 'SAVE $' + Math.round(was - now);
          lab.setAttribute('data-ttw', '1');
          return;
        }
      }
      lab.textContent = 'SALE';
      lab.setAttribute('data-ttw', '1');
    });
  }

  /* Review ko .product-info ka seedha bachha banao taake wo grid
     ka khana ban sake (rang ke nishan ke saamne). Theme use naam
     wale link ke andar rakhta hai - wahan se grid mein jagah nahi
     milti. */
  function ratingInInfo() {
    var cards = document.querySelectorAll('.product-block');
    Array.prototype.forEach.call(cards, function (card) {
      var rat = card.querySelector('.product-block__rating');
      var info = card.querySelector('.product-info');
      if (rat && info && rat.parentElement !== info) info.appendChild(rat);
    });
  }

  function tileFirst() {
    var list = document.querySelector('.product-list');
    if (!list) return;
    var tile = list.querySelector('a.ttw-tile');
    if (!tile) return;
    if (list.firstElementChild !== tile) list.insertBefore(tile, list.firstElementChild);
  }

  function tileCopy() {
    if (!window.TTW_TILE) return;
    var tile = document.querySelector('a.ttw-tile');
    if (!tile || tile.getAttribute('data-ttw-copy') === '1') return;
    var d = window.TTW_TILE;
    var h = tile.querySelector('h3');
    var m = tile.querySelector('.m');
    var sv = tile.querySelector('.sv');
    var fine = tile.querySelector('.fine');
    if (h && d.h) h.innerHTML = d.h;
    if (m && d.m) m.innerHTML = d.m;
    if (sv && d.sv) sv.innerHTML = d.sv;
    if (fine && d.fine) fine.innerHTML = d.fine;
    if (d.href) tile.setAttribute('href', d.href);
    tile.setAttribute('data-ttw-copy', '1');
  }

  function run() { labels(); ratingInInfo(); tileFirst(); tileCopy(); }

  function start() {
    run();
    var list = document.querySelector('.product-list');
    if (!list || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 60);
    }).observe(list.parentNode || list, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(run, 1200);
  setTimeout(run, 2500);
})();

/* ===== ttw-pdp script #2 ===== */
(function () {
  'use strict';

  function tidy(s) { return String(s || '').trim(); }

  /* 13 Aug (Round 5): "Length"/"Lenght" ko turant "Length (inches)"
     bana dete hain jahan naam nikala jata hai (ttw-size.liquid ka
     apna swapText() bhi yehi karta hai baad mein, magar dono
     scripts ke chalne ka order guaranteed nahi - is liye naam yahin
     seedha theek kar dena zyada bharosemand hai, kisi doosri file
     ke timing par munhasir nahi). */
  function fixOptName(name) {
    var t = tidy(name);
    var low = t.toLowerCase();
    if (low.indexOf('accessory size') > -1) return t.replace(/accessory size/ig, 'Body size (chest)');
    if (low.indexOf('lenght') > -1) return t.replace(/lenght/ig, 'Length (inches)');
    if (low.indexOf('length') > -1 && low.indexOf('inches') === -1) return t.replace(/length/ig, 'Length (inches)');
    return t;
  }

  function breadcrumb() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.ttw-bc')) return;
    var tpl = document.getElementById('ttw-bc-tpl');
    var host = document.querySelector('.detail .title-row') || document.querySelector('.detail h1');
    if (!tpl || !host) return;
    var d = document.createElement('div');
    d.innerHTML = tpl.innerHTML;
    host.parentNode.insertBefore(d.firstElementChild, host);
  }

  function splitLabels() {
    var labels = document.querySelectorAll('.option-selector legend.label, .option-selector .label');
    Array.prototype.forEach.call(labels, function (lab) {
      if (lab.querySelector('.ttw-opt-name')) return;
      var t = tidy(lab.textContent);
      if (!t) return;
      var i = t.indexOf(':');
      var name = i > -1 ? t.slice(0, i).trim() : t;
      var val = i > -1 ? t.slice(i + 1).trim() : '';
      name = fixOptName(name);
      lab.textContent = '';
      var a = document.createElement('span');
      a.className = 'ttw-opt-name';
      a.textContent = name;
      lab.appendChild(a);
      if (val) {
        var b = document.createElement('span');
        b.className = 'ttw-opt-val';
        b.textContent = val;
        lab.appendChild(b);
      }
    });
  }

  function shipLine() {
    // 11 Aug malik: ye line hata di - neeche 3-column trust row mein
    // "FREE US SHIPPING" pehle se likha hai, dohrai lag rahi thi.
    return;
  }

  function accordions() {
    var sums = document.querySelectorAll('.detail details > summary');
    Array.prototype.forEach.call(sums, function (s) {
      if (s.querySelector('.ttw-acc-sign')) return;
      var t = tidy(s.textContent);
      var last = t.charAt(t.length - 1);
      if (last === '+' || last === '-') t = t.slice(0, -1).trim();
      s.textContent = '';
      var a = document.createElement('span');
      a.textContent = t;
      var b = document.createElement('span');
      b.className = 'ttw-acc-sign';
      b.textContent = s.parentNode.open ? '-' : '+';
      s.appendChild(a);
      s.appendChild(b);
      s.parentNode.addEventListener('toggle', function () {
        b.textContent = s.parentNode.open ? '-' : '+';
      });
    });
  }

  /* 13 Aug (Round 7): Size Guide template ab har .product-detail ke
     apne andar, per-product render hoti hai (snippets/ttw-sg-guide.
     liquid, class=".ttw-sg-tpl" - id nahi, taake do instances kabhi
     collide na karein). Purana code do bugs rakhta tha:
       (a) `document.getElementById('ttw-sg-tpl')` HAMESHA poore
           document ka pehla (globally-rendered, hamesha Thobe/pehle
           product ka) template uthata - Quick Add popup apne khud
           ke product ka guide kabhi nahi dekh pata.
       (b) `if (back) { ...reuse...; return; }` - dusri baar (chahe
           kisi bhi doosre product ke button se) khulne par bhi
           PEHLI baar wala stale content hi dikhta rehta.
     Hal: clicked button ka apna `.product-detail` root openGuide()
     ko diya jata hai (place() se), aur box ka content HAR open()
     par fresh tpl se dobara banaya jata hai. */
  var back = null;
  function openGuide(root) {
    var tpl = (root && root.querySelector('.ttw-sg-tpl')) || document.querySelector('.ttw-sg-tpl');
    if (!tpl) return;
    if (!back) {
      back = document.createElement('div');
      back.className = 'ttw-sg-back';
      document.body.appendChild(back);
      back.addEventListener('click', function (e) { if (e.target === back) closeGuide(); });
    }
    back.innerHTML = '';
    var box = document.createElement('div');
    box.className = 'ttw-sg-box';
    box.innerHTML = '<button class="ttw-sg-x" aria-label="Close">&times;</button>' + tpl.innerHTML;
    back.appendChild(box);
    back.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    box.querySelector('.ttw-sg-x').addEventListener('click', closeGuide);
  }
  function closeGuide() {
    if (back) back.style.display = 'none';
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGuide(); });

  function guideButtons() {
    var containers = document.querySelectorAll('.product-detail');
    if (!containers.length) containers = [document];

    function place(lab, root) {
      if (!lab || lab.querySelector('.ttw-sg-btn')) return false;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ttw-sg-btn';
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 8h18v8H3z"/><path d="M7 8v4M11 8v3M15 8v4M19 8v3"/></svg><span>Size guide</span>';
      b.addEventListener('click', function () { openGuide(root); });
      lab.appendChild(b);
      b.classList.add('ttw-pulse');
      setTimeout(function () { b.classList.remove('ttw-pulse'); }, 6000);
      return true;
    }
    function findLabel(root, keyword) {
      var sels = root.querySelectorAll('.option-selector');
      var found = null;
      Array.prototype.forEach.call(sels, function (sel) {
        if (found) return;
        var lab = sel.querySelector('legend.label, .label');
        if (!lab) return;
        var nameEl = lab.querySelector('.ttw-opt-name');
        var name = tidy(nameEl ? nameEl.textContent : lab.textContent).toLowerCase();
        if (name.indexOf(keyword) > -1) found = lab;
      });
      return found;
    }
    Array.prototype.forEach.call(containers, function (root) {
      var sizeLab = findLabel(root, 'size');
      var lengthLab = findLabel(root, 'length');
      if (sizeLab) place(sizeLab, root);
      if (lengthLab) place(lengthLab, root);
    });
  }

  function lengthTwoRows() {
    var sels = document.querySelectorAll('.option-selector');
    Array.prototype.forEach.call(sels, function (sel) {
      var lab = sel.querySelector('legend.label, .label');
      if (!lab) return;
      var nameEl = lab.querySelector('.ttw-opt-name');
      var name = tidy(nameEl ? nameEl.textContent : lab.textContent).toLowerCase();
      if (name.indexOf('length') === -1) return;
      var btns = sel.querySelector('.option-selector__btns');
      if (!btns) return;
      var n = btns.querySelectorAll(':scope > input.opt-btn').length || Math.ceil(btns.children.length / 2);
      if (n > 6) {
        sel.classList.add('ttw-len-wrap');
        btns.style.setProperty('--ttw-cols', Math.ceil(n / 2));
      } else {
        sel.classList.remove('ttw-len-wrap');
        btns.style.removeProperty('--ttw-cols');
      }
    });
  }

  function reflowPriceBits() {
    if (window.innerWidth > 749) return;
    var containers = document.querySelectorAll('.product-detail');
    Array.prototype.forEach.call(containers, function (root) {
      var form = root.querySelector('.product-form');
      if (!form) return;
      var descriptors = form.querySelector('.price-descriptors');
      var buyRow = form.querySelector('.buy-buttons-row');
      if (!descriptors || !buyRow) return;
      if (!descriptors.textContent || !tidy(descriptors.textContent)) return;
      if (descriptors.previousElementSibling === buyRow) return; // already moved
      buyRow.parentNode.insertBefore(descriptors, buyRow.nextSibling);
    });
  }

  function run() { breadcrumb(); splitLabels(); shipLine(); accordions(); guideButtons(); lengthTwoRows(); reflowPriceBits(); }

  function start() {
    var onPDP = document.body.classList.contains('template-product');
    run();
    if (!onPDP || !window.MutationObserver) return;
    var host = document.querySelector('.detail.product-column-right') || document.querySelector('.product-detail');
    if (!host) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  /* 17 Aug (Round 11): Quick Add DRAWER mein length select karne
     ke baad 2-row fix toot jata tha. WAJAH: PDP par upar wala
     MutationObserver .detail.product-column-right ko watch karta
     hai aur variant select hone par re-render hote hi run() dobara
     chala deta hai - magar wo observer sirf onPDP (body.template-
     product) hone par lagta hai, collection/home page par kabhi
     nahi. Drawer wahi PDP markup reuse karta hai (.quickbuy-content
     .detail.product-column-right) lekin collection page par khulta
     hai, is liye observer sirey se lagta hi nahi tha - sirf toggle
     click par do one-time setTimeout(run) chalte the. Result: drawer
     khulte hi sahi 2 rows dikhte, magar length select karte hi jo
     re-render hota us par koi observer nahi tha to purani 1-row
     halat wapas aa jati. HAL: toggle click par drawer host mil jaye
     to usi tarah ka MutationObserver khud lagao. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.quickbuy-toggle')) {
      setTimeout(run, 500);
      setTimeout(run, 1200);
      setTimeout(watchQuickbuyDrawer, 500);
      setTimeout(watchQuickbuyDrawer, 1200);
    }
  });

  function watchQuickbuyDrawer() {
    if (!window.MutationObserver) return;
    var host = document.querySelector('.quickbuy-content .detail.product-column-right') || document.querySelector('.quickbuy-content.product-detail');
    if (!host || host.__ttwObserved) return;
    host.__ttwObserved = true;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 80);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(start, 1200);
})();

/* ===== ttw-shuffle script #0 ===== */
(function () {
  'use strict';
  function shuffle(list) {
    var kids = [];
    var i;
    for (i = 0; i < list.children.length; i++) {
      if (list.children[i].classList.contains('product-block')) kids.push(list.children[i]);
    }
    if (kids.length < 3) return false;
    for (i = kids.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = kids[i];
      kids[i] = kids[j];
      kids[j] = tmp;
    }
    var frag = document.createDocumentFragment();
    for (i = 0; i < kids.length; i++) frag.appendChild(kids[i]);
    list.appendChild(frag);
    return true;
  }
  function run() {
    var sec = document.querySelector('.section-featured-collection');
    if (!sec || sec.getAttribute('data-ttw-shuffled') === '1') return;
    var list = sec.querySelector('.product-list, .cc-carousel__scroll-area');
    if (!list) return;
    if (shuffle(list)) sec.setAttribute('data-ttw-shuffled', '1');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 900);
})();

/* ===== ttw-toplinks script #1 ===== */
(function () {
  'use strict';

  var back = null;

  function close() {
    if (back) back.style.display = 'none';
    document.body.style.overflow = '';
  }

  function open() {
    if (back) { back.style.display = 'flex'; document.body.style.overflow = 'hidden'; return; }
    var tpl = document.getElementById('ttw-tlm-tpl');
    if (!tpl) return;
    back = document.createElement('div');
    back.className = 'ttw-tlm-back';
    var box = document.createElement('div');
    box.className = 'ttw-tlm-box';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button class="ttw-tlm-x" aria-label="Close">&times;</button>' + tpl.innerHTML;
    back.appendChild(box);
    document.body.appendChild(back);
    document.body.style.overflow = 'hidden';
    box.querySelector('.ttw-tlm-x').addEventListener('click', close);
    back.addEventListener('click', function (e) { if (e.target === back) close(); });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-ttw-offer]') : null;
    if (!t) return;
    e.preventDefault();
    open();
  });

  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h18v8H3z"/><path d="M7 8v4M11 8v3M15 8v4M19 8v3"/></svg>';
  var BOX = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 8v12H3V8"/><path d="M1 3h22v5H1z"/><path d="M10 12h4"/></svg>';
  var CAP = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 9 12 4 2 9l10 5 10-5z"/><path d="M6 11.5V16c0 1.5 3 3 6 3s6-1.5 6-3v-4.5"/></svg>';

  function pill(cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ttw-tl-pill' + (cls ? ' ' + cls : '');
    b.setAttribute('data-ttw-offer', '');
    b.innerHTML = BOX + '<span>Wholesale / Bulk Orders</span>';
    return b;
  }

  function add() {
    var bar = document.querySelector('.announcement-bar');
    if (!bar || bar.querySelector('.ttw-tl-pill')) return;

    var right = bar.querySelector('.announcement-bar__right');
    var first = null;
    if (right) {
      first = pill('');
      right.appendChild(first);
    }

    var wrap = document.createElement('div');
    wrap.className = 'ttw-tl-m';
    wrap.appendChild(pill(''));
    bar.appendChild(wrap);

    var p = first || wrap.querySelector('.ttw-tl-pill');
    if (p) {
      p.classList.add('ttw-tl-pulse');
      setTimeout(function () { p.classList.remove('ttw-tl-pulse'); }, 6000);
    }
  }

  function drawer() {
    var d = document.getElementById('MobileNavigationDrawer');
    if (!d || d.querySelector('.ttw-dl')) return;
    var foot = d.querySelector('.mobile-navigation-drawer__footer');
    var box = document.createElement('div');
    box.className = 'ttw-dl';
    box.innerHTML =
      '<a href="/pages/adult-thobe-size-guide">' + RULER + '<span>Size guide</span></a>' +
      '<a href="/pages/wholesale-islamic-clothing-bulk-thobes-custom-orders">' + BOX + '<span>Wholesale enquiry</span></a>' +
      '<a href="/pages/school-uniforms">' + CAP + '<span>School uniforms</span></a>' +
      '<button type="button" data-ttw-offer>' + BOX + '<span>Wholesale / bulk order form</span></button>';
    if (foot) { d.insertBefore(box, foot); } else { d.appendChild(box); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { add(); drawer(); });
  } else {
    add();
    drawer();
  }
  setTimeout(function () { add(); drawer(); }, 900);
  setTimeout(function () { drawer(); }, 2200);
})();

/* ===== ttw-bestsellers-arrows script #0 ===== */
(function () {
  function init() {
    var section = document.querySelector('[id$="__bestsellers"]');
    if (!section) return;

    var titleEl = section.querySelector('.section-title');
    var buttonsWrap = section.querySelector('.cc-carousel-buttons');
    var carousel = section.querySelector('cc-carousel');
    if (!titleEl || !buttonsWrap || !carousel) return;
    if (titleEl.closest('.ttwba-headrow')) return;

    var row = document.createElement('div');
    row.className = 'ttwba-headrow';
    titleEl.parentNode.insertBefore(row, titleEl);
    row.appendChild(titleEl);
    section.classList.add('ttwba-side-arrows');

    var AUTOPLAY_MS = 3500;
    var nextBtn = buttonsWrap.querySelector('.cc-carousel-button--next');
    var list = section.querySelector('.product-list');
    if (!nextBtn) return;

    function ensureReady() {
      try {
        if (carousel.scrollArea === undefined && carousel.prepare) { carousel.prepare(); }
      } catch (e) {}
    }
    function slide(dir) {
      ensureReady();
      var before = list ? list.scrollLeft : 0;
      try { if (dir > 0) { carousel.next(); } else { carousel.prev(); } } catch (e) {}
      setTimeout(function () {
        if (!list) return;
        if (Math.abs(list.scrollLeft - before) < 5) {
          var cards = list.querySelectorAll('.product-block');
          var step = (cards.length > 1)
            ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left)
            : Math.round(list.clientWidth * 0.7);
          if (!(step > 40)) { step = Math.round(list.clientWidth * 0.7); }
          var oldSnap = list.style.scrollSnapType;
          list.style.scrollSnapType = 'none';
          list.scrollBy({ left: dir * step, behavior: 'smooth' });
          setTimeout(function () { list.style.scrollSnapType = oldSnap; }, 700);
        }
      }, 350);
    }
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); slide(1); });
    var prevBtn = buttonsWrap.querySelector('.cc-carousel-button--prev');
    if (prevBtn) { prevBtn.addEventListener('click', function (e) { e.preventDefault(); slide(-1); }); }
    ensureReady();

    var timer = null;

    function tick() {
      if (list && list.scrollLeft + list.clientWidth >= list.scrollWidth - 10) {
        var oldSnap = list.style.scrollSnapType;
        list.style.scrollSnapType = 'none';
        list.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(function () { list.style.scrollSnapType = oldSnap; }, 700);
        return;
      }
      slide(1);
    }
    function play() {
      stop();
      timer = setInterval(tick, AUTOPLAY_MS);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function stopForGood() { stop(); }
    carousel.addEventListener('pointerdown', stopForGood, { once: true });
    carousel.addEventListener('wheel', stopForGood, { once: true, passive: true });
    buttonsWrap.addEventListener('pointerdown', stopForGood, { once: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!timer) { play(); }
    });

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReduced) { play(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===== ttw-signup script #0 ===== */
(function(){
  'use strict';
  var h = document.getElementById('ttw-sign-h');
  if (!h) return;
  function jump(){
    var form = h.closest('.ttw-sign').querySelector('form');
    var input = h.closest('.ttw-sign').querySelector('input[type="email"]');
    if (!input) return;
    input.focus();
    if (form) {
      form.classList.add('ttw-sign-nudge');
      setTimeout(function(){ form.classList.remove('ttw-sign-nudge'); }, 1400);
    }
  }
  h.addEventListener('click', jump);
  h.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); jump(); }
  });
})();

/* ===== ttw-custom script #0 ===== */
window.addEventListener('load', function () {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "xde215e1y4");
  });

/* ===== ttw-loadmore script #0 ===== */
(function () {
  'use strict';

  var pagRow = document.querySelector('.pagination-row');
  if (!pagRow) return;

  var nextLink = pagRow.querySelector('a.next');
  if (!nextLink) return;

  /* 13 Aug (blog Load More): pehle sirf '.product-block' dhoondte
     the (collection pages), is liye blog page par ('.article-block'
     cards use karta hai) ye script chalta hi nahi tha aur numbered
     1-2-3 pagination hi dikhti rehti thi. Ab dono card types support
     karte hain - jo bhi page ho, sahi wala match ho jayega (dono ek
     sath kabhi ek page par nahi hote). */
  var firstCard = document.querySelector('.product-block, .article-block');
  if (!firstCard) return;
  var grid = firstCard.parentNode;

  pagRow.classList.add('ttw-lm-hidden');

  var wrap = document.createElement('div');
  wrap.className = 'ttw-lm-wrap';
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'ttw-lm';
  btn.textContent = 'Load more';
  wrap.appendChild(btn);
  pagRow.parentNode.insertBefore(wrap, pagRow);

  var url = nextLink.getAttribute('href');
  var busy = false;

  btn.addEventListener('click', function () {
    if (busy || !url) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Loading...';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.product-block, .article-block');

        Array.prototype.forEach.call(cards, function (c) {
          c.classList.add('ttw-lm-new');
          grid.appendChild(document.importNode(c, true));
        });

        try { window.history.replaceState({}, '', url); } catch (e) {}

        var nextPag = doc.querySelector('.pagination-row a.next');
        url = nextPag ? nextPag.getAttribute('href') : null;

        window.dispatchEvent(new Event('scroll'));
        window.dispatchEvent(new Event('resize'));

        if (url) {
          btn.disabled = false;
          btn.textContent = 'Load more';
        } else {
          wrap.innerHTML = '<span class="ttw-lm-end">That is everything</span>';
        }
        busy = false;
      })
      .catch(function () {
        pagRow.classList.remove('ttw-lm-hidden');
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        busy = false;
      });
  });
})();
